// import { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './BookCard.module.css';

const BookCard = props => {
  return (
    <Button
      className={classes.cardContainer}
      component={Link}
      to={`/product/book/${props.itemData.idAcademy}/${props.itemData.keyBook}`}
    >
      <figure className={classes.bookImage}>
        <img
          src={props.itemData.bookImage}
          className={classes.img}
        />
      </figure>
      <aside className={classes.complementaryInfoContainer}>
        <p className={classes.bookTitle}>
          {props.itemData.bookShortName}
        </p>
        <p className={classes.bookTitle}>
          {props.itemData.bookType}
        </p>
        <p className={classes.bookPrice}>
          $ {props.itemData.bookPrice / 100}{' '}
          {props.itemData.currency}
        </p>
      </aside>
    </Button>
  );
};

BookCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemData: PropTypes.object
};

export default BookCard;
